import { Shield, Clock } from "lucide-react";

export const Support = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            We are always here for your backup
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We share common trends and strategies for creating & improving your text-nowrap rental income.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-12">
          {/* Noise Free Locations */}
          <div className="bg-gray-50 p-8 rounded-lg">
            <div className="flex items-center mb-4">
              <Shield className="w-8 h-8 text-primary mr-3" />
              <h3 className="text-xl font-semibold text-gray-900">Noise Free Locations</h3>
            </div>
            <p className="text-gray-600">
              We ensure noise-free locations for your peace of mind and sound sleep.
            </p>
          </div>

          {/* 24/7 Hour Support */}
          <div className="bg-gray-50 p-8 rounded-lg">
            <div className="flex items-center mb-4">
              <Clock className="w-8 h-8 text-primary mr-3" />
              <h3 className="text-xl font-semibold text-gray-900">24/7 Hour Support</h3>
            </div>
            <p className="text-gray-600">
              Get support from our efficient customer support team, 24/7, all year round.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};